module.exports = __webpack_public_path__ + "static/media/awardLogo.93dfac6d.svg";